import { useState } from 'react'
import { getErrorMessage } from '@/shared/lib'
import { useLoginAndProfileRepository } from '@/features/repositories/useLoginAndProfileRepository'

export const useProfileManagement = () => {
    const [newProfile, setNewProfile] = useState<{
        version: number
        profile_name: string
        isKid: boolean
        order: string
        iconId: string
    } | null>(null)
    const { postUserProfile } = useLoginAndProfileRepository()
    const createProfile = (callback?: () => void) => {
        if (newProfile?.order) {
            postUserProfile(newProfile)
                .then(() => {
                    setNewProfile(null)
                    callback && callback()
                })
                .catch((error) => {
                    getErrorMessage('Failed to set profile:', error)
                })
        }
    }

    const cancelProfile = () => setNewProfile(null)

    const isNewProfileSet = !!newProfile?.order && !newProfile?.profile_name

    return {
        createProfile,
        cancelProfile,
        isNewProfileSet,
        newProfile,
        setNewProfile,
    }
}
